export default __webpack_public_path__ + "static/media/iconAdmin.910bad94.svg";